import React, { useState } from "react";
import { DisplayText, TextStyle, Button, Modal } from "@shopify/polaris";
import callApi from "../../utils/apiCaller";
import PlanTable from "../Dashboard/PlanTable";
import step4 from "../../assets/welcome_4.webp";
const Step4 = () => {
  const [modalPlan, setModalPlan] = useState(false);
  const connectToPayPal = () => {
    let params = {
      action: "connectToPayPal",
    };
    callApi("get", params).then(async (res) => {
      if (res.data.state === 1) {
        // window.top.location..urlhref = res.data.url;
        window.open(res.data.url, "connect paypal", "width=500,height=500");
      }
    });
  };
  const pickAPlan = () => {
    setModalPlan(true);
    let params = {
      action: "updateWelcomeStep",
      step: 5,
    };
    callApi("get", params).then(async (res) => {});
  };
  return (
    <div className="tab-pane">
      <div className="panel-heading pb-4 text-center">
        <DisplayText size="medium">All is done</DisplayText>
      </div>
      <div className="panel-body">
        <div className="text-center">
          <img style={{ width: "80%" }} src={step4} alt="Responsive image" />
          <DisplayText size="medium">
            Do you have more than 30 orders to sync monthly?
          </DisplayText>
          <p className="text-center mt-4" style={{ fontSize: "16px" }}>
            <TextStyle variation="subdued">
              Pick a plan to get all your orders synced. Otherwise, only 30
              orders will be synced.
            </TextStyle>
          </p>
          <div className="mt-4 text-center">
            <Button onClick={() => pickAPlan()} size="large" fullWidth primary>
              Pick A Plan
            </Button>
          </div>
        </div>
      </div>
      <Modal
        large={true}
        open={modalPlan}
        onClose={() => setModalPlan(false)}
        title="Pricing Table"
        secondaryActions={[
          {
            content: "Cancel",
            onAction: () => setModalPlan(false),
          },
        ]}
      >
        <Modal.Section>
          <PlanTable type="step" />
        </Modal.Section>
      </Modal>
    </div>
  );
};

export default Step4;
